<div class="chat-message-label body-40 mb-1" data-automation-id="f-chat-message-info">
  {{ name }}
  {{ timestamp }}
</div>
